export var _langList = [
    {
        v: "zh-CN",
        a: "中文 (简体)",
        z: "中文 (简体)",
        s: [
            "zh",
            "zh-cn",
            "zh-hans"
        ]
    },
    {
        v: "en-US",
        a: "English",
        z: "英语",
        s: "en"
    },
    {
        v: "ja-JP",
        a: "日本語",
        z: "日本语",
        s: "ja"
    },
    {
        v: "ru-RU",
        a: "Русский",
        z: "俄语",
        s: "ru"
    },
    {
        v: "pt-PT",
        a: "Portugu\xeas (Portugal)",
        z: "葡萄牙语 (葡萄牙)",
        s: "pt"
    },
    {
        v: "fr-FR",
        a: "Fran\xe7ais",
        z: "法语",
        s: "fr"
    },
    {
        v: "es-ES",
        a: "Espa\xf1ol",
        z: "西班牙语",
        s: "es"
    },
    {
        a: "中文 (香港)",
        v: "zh-HK",
        z: "中文 (香港)",
        l: [
            "zh-TW",
            "zh-CN"
        ],
        s: [
            "zh-hk",
            "zh-hant-hk",
            "zh-hant"
        ]
    },
    {
        a: "中文 (繁體)",
        v: "zh-TW",
        z: "中文 (繁体)",
        l: [
            "zh-HK",
            "zh-CN"
        ],
        s: [
            "zh-tw",
            "zh-hant-tw"
        ]
    },
    {
        a: "한국어",
        v: "ko-KR",
        z: "韩语",
        s: "ko"
    },
    {
        a: "T\xfcrk\xe7e",
        v: "tr-TR",
        z: "土耳其语",
        s: "tr"
    },
    {
        a: "Polski",
        v: "pl-PL",
        z: "波兰语",
        s: "pl"
    },
    {
        a: "עברית",
        v: "he-IL",
        z: "希伯来语",
        l: [
            "iw-IL"
        ],
        s: "he"
    },
    {
        a: "עברית (ישן)",
        v: "iw-IL",
        z: "希伯来语 (传统)",
        l: [
            "he-IL"
        ],
        s: "iw"
    },
    {
        a: "Italiano",
        v: "it-IT",
        z: "意大利语",
        s: "it"
    },
    {
        a: "عربية",
        v: "ar-SA",
        z: "阿拉伯语",
        s: "ar"
    },
    {
        a: "Čeština",
        v: "cs-CZ",
        z: "捷克语",
        s: "cs"
    },
    {
        a: "Dansk",
        v: "da-DK",
        z: "丹麦语",
        s: "da"
    },
    {
        a: "Nederlands",
        v: "nl-NL",
        z: "荷兰语",
        s: "nl"
    },
    {
        a: "Deutsch",
        v: "de-DE",
        z: "德语",
        s: "de"
    },
    {
        a: "हिन्दी",
        v: "hi-IN",
        z: "印地语",
        s: "hi"
    },
    {
        a: "Magyar",
        v: "hu-HU",
        z: "匈牙利语",
        s: "hu"
    },
    {
        a: "Bahasa Melayu",
        v: "ms-MY",
        z: "马来语",
        s: "ms"
    },
    {
        a: "Bahasa Indonesia",
        v: "id-ID",
        z: "印尼语",
        l: [
            "in-ID"
        ],
        s: "id"
    },
    {
        a: "Bahasa Indonesia (Tradisional)",
        v: "in-ID",
        z: "印尼语 (传统)",
        l: [
            "id-ID"
        ],
        s: "in"
    },
    {
        a: "Rom\xe2nă",
        v: "ro-RO",
        z: "罗马尼亚语",
        s: "ro"
    },
    {
        a: "Српски",
        v: "sr-SA",
        z: "塞尔维亚语",
        s: "sr"
    },
    {
        a: "Slovenčina",
        v: "sk-SK",
        z: "斯洛伐克语",
        s: "sk"
    },
    {
        a: "Svenska",
        v: "sv-SE",
        z: "瑞典语",
        s: "sv"
    },
    {
        a: "ภาษาไทย",
        v: "th-TH",
        z: "泰语",
        s: "th"
    },
    {
        a: "Українська",
        v: "uk-UA",
        z: "乌克兰语",
        s: "uk"
    },
    {
        a: "Tiếng Việt",
        v: "vi-VN",
        z: "越南语",
        s: "vi"
    },
    {
        v: "pt-BR",
        a: "Portugu\xeas (Brasil)",
        z: "葡萄牙语 (巴西)",
        s: "pt-br",
        l: [
            "pt-PT"
        ]
    },
    {
        v: "en-ID",
        a: "English (ID)",
        z: "英语 (印度尼西亚)",
        l: [
            "en-US"
        ],
        s: [
            "en-id",
            "en"
        ]
    },
    {
        v: "en-MY",
        a: "English (MY)",
        z: "英语 (马来西亚)",
        l: [
            "en-US"
        ],
        s: [
            "en-my",
            "en"
        ]
    },
    {
        v: "en-PH",
        a: "English (PH)",
        z: "英语 (菲律宾)",
        l: [
            "en-US"
        ],
        s: [
            "en-ph",
            "en"
        ]
    },
    {
        v: "en-SG",
        a: "English (SG)",
        z: "英语 (新加坡)",
        l: [
            "en-US"
        ],
        s: [
            "en-sg",
            "en"
        ]
    },
    {
        v: "en-TH",
        a: "English (TH)",
        z: "英语 (泰国)",
        l: [
            "en-US"
        ],
        s: [
            "en-th",
            "en"
        ]
    },
    {
        v: "en-VN",
        a: "English (VN)",
        z: "英语 (越南)",
        l: [
            "en-US"
        ],
        s: [
            "en-vn",
            "en"
        ]
    },
    {
        v: "es-MX",
        a: "Espa\xf1ol (Mexico)",
        z: "西班牙语 (墨西哥)",
        l: [
            "es-ES"
        ],
        s: [
            "es-mx",
            "es"
        ]
    },
    {
        v: "en-GB",
        a: "English (UK)",
        z: "英语 (英国)",
        l: [
            "en-US"
        ],
        s: [
            "en-gb",
            "en"
        ]
    },
    {
        v: "es-419",
        a: "Espa\xf1ol (Latinoam\xe9rica)",
        z: "西班牙语 (拉丁美洲)",
        l: [
            "es-ES"
        ],
        s: [
            "es-419",
            "es-la"
        ]
    },
    {
        v: "el-GR",
        a: "Ελληνικά",
        z: "希腊语",
        s: "el"
    },
    {
        v: "fr-CA",
        a: "Fran\xe7ais (Canada)",
        z: "法语 (加拿大)",
        l: [
            "fr-FR"
        ],
        s: [
            "fr-ca",
            "fr"
        ]
    },
    {
        v: "bn-BD",
        a: "বাংলা",
        z: "孟加拉语",
        s: "bn"
    },
    {
        v: "ur-PK",
        a: "اردو",
        z: "乌尔都文",
        s: "ur"
    },
    {
        v: "my-MM",
        a: "မြန်မာဘာသာ",
        z: "缅甸语",
        s: "my"
    },
    {
        v: "lo-LA",
        a: "ພາສາລາວ",
        z: "老挝语",
        s: "lo"
    },
    {
        v: "fa-IR",
        a: "فارسی",
        z: "波斯语",
        s: "fa"
    },
    {
        v: "uz-UZ",
        a: "O‘zbek",
        z: "乌兹别克语",
        s: "uz"
    },
    {
        v: "tl-PH",
        a: "Filipino",
        z: "菲律宾语",
        s: [
            "tl",
            "fil"
        ]
    },
    {
        v: "ne-NE",
        a: "नेपाली",
        z: "尼泊尔语",
        s: "ne"
    },
    {
        v: "si-LK",
        a: "සිංහල",
        z: "僧伽罗语",
        s: "si"
    }
];
var langList = [];
var zhLangList = [];
var langMap = {};
_langList.forEach(function(item) {
    var alias = item.v.charAt(0).toUpperCase() + item.v.charAt(1);
    langList.push({
        label: item.a,
        value: item.v,
        alias: alias
    });
    zhLangList.push({
        label: item.z,
        value: item.v,
        alias: alias
    });
    langMap[item.v] = item;
});
var localLangMap = {
    es: "es-ES",
    en: "en-US",
    pt: "pt-PT",
    fr: "fr-FR",
    nl: "nl-NL",
    ar: "ar-SA",
    de: "de-DE",
    ru: "ru-RU"
};
export { langList, zhLangList, langMap, localLangMap };
